import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  brandColours,
  fontSize,
  visuallyHidden,
} from '../styles';
import { Link } from './ui';

const StyledPagination = styled.nav`
  padding: 30px 0;

  ${minBreakpointQuery.small`
    padding-top: 40px;
    padding-bottom: 40px;
  `}

  ${minBreakpointQuery.large`
    padding-top: 50px;
    padding-bottom: 50px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding-top: 60px;
    padding-bottom: 60px;
  `}
`;

const StyledItems = styled.ol`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledItem = styled.li`
  margin: 5px;
`;

const commonLinkStyles = () => {
  return css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    height: 50px;
    width: 50px;
    ${fontSize(18)};
    background-color: ${brandColours.quaternary};

    &.pagination-prev,
    &.pagination-next {
      &:after {
        content: '➔';
      }
    }

    &.pagination-prev {
      &:after {
        transform: rotate(180deg);
      }
    }

    &.pagination-active {
      color: ${brandColours.quaternary};
      background-color: ${brandColours.primary};
    }

    span {
      ${visuallyHidden()};
    }
  `;
};

const StyledLink = styled(Link)`
  ${commonLinkStyles()};
`;

const StyledGatsbyLink = styled(GatsbyLink)`
  ${commonLinkStyles()};
`;

const Pagination = ({ baseUrl, currentPage, totalPages, isClientSide }) => {
  const urlPattern = isClientSide ? '?page=' : 'page/';
  const LinkComponent = isClientSide ? StyledGatsbyLink : StyledLink;

  return (
    totalPages > 0 && (
      <StyledPagination>
        <StyledItems>
          {currentPage !== 1 && (
            <StyledItem>
              <LinkComponent
                to={`${baseUrl}${
                  currentPage > 2 ? `${urlPattern}${currentPage - 1}` : ''
                }`}
                className="pagination-prev"
              >
                <span>Previous Page</span>
              </LinkComponent>
            </StyledItem>
          )}

          {[...Array(totalPages)].map((item, i) => {
            const pageCount = i + 1;

            return (
              <StyledItem>
                <LinkComponent
                  to={`${baseUrl}${
                    pageCount > 1 ? `${urlPattern}${pageCount}` : ''
                  }`}
                  className={pageCount === currentPage && 'pagination-active'}
                >
                  {pageCount}
                </LinkComponent>
              </StyledItem>
            );
          })}

          {currentPage !== totalPages && (
            <StyledItem>
              <LinkComponent
                to={`${baseUrl}${`${urlPattern}${currentPage + 1}`}`}
                className="pagination-next"
              >
                <span>Next Page</span>
              </LinkComponent>
            </StyledItem>
          )}
        </StyledItems>
      </StyledPagination>
    )
  );
};

export default Pagination;
